import { Box, Button, Container, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useAppBase } from '../components/appBase'

export default function NotFoundPage() {
  const navigate = useNavigate()
  const base = useAppBase()
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          gap: 1,
        }}
      >
        <Typography
          variant="h1"
          fontWeight={800}
          sx={{ color: 'primary.main', lineHeight: 1 }}
        >
          404
        </Typography>
        <Typography variant="h6" fontWeight={700}>
          Page not found
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          The page you're looking for doesn't exist or may have moved.
        </Typography>
        <Button variant="contained" onClick={() => navigate(base)}>
          Go to event home
        </Button>
      </Box>
    </Container>
  )
}
